module.exports = __webpack_public_path__ + "prod/1.2.3/img/selectIcon.0774ac88.svg";